import { render, staticRenderFns } from "./SignCheckStatic.vue?vue&type=template&id=9710e13e&scoped=true&"
import script from "./SignCheckStatic.vue?vue&type=script&lang=js&"
export * from "./SignCheckStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9710e13e",
  null
  
)

export default component.exports